const SalesListings = [
    {
        id: "invoice",
        label: window.i18n.__("Factures"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter une facture"),
                "href": `javascript:DocTools.createForThird('invoice', '${window.i18n.__('Créer une facture')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "invoice",
        name: "saleinvoices",
        params: {
        },
        savedSearchesUrl: "/savedsearch/docinvoices",
        switchDisplay: false,
        group: 'sales',
        favoritesName: '',
    },
    {
        id: "invoicedraft",
        label: window.i18n.__("Factures brouillon"),
        buttons: [
            {
                "label": window.i18n.__("Créer une facture brouillon"),
                "href": `javascript:DocTools.createForThird('invoice', '${window.i18n.__('Créer une facture brouillon')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "invoice",
        name: "saledraftinvoices",
        params: {
        },
        switchDisplay: false,
        group: 'sales',
        favoritesName: '',
    },
    {
        id: "estimate",
        label: window.i18n.__("Devis"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter un devis"),
                "href": `javascript:DocTools.createForThird('estimate', '${window.i18n.__('Créer un devis')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "estimate",
        name: "saleestimates",
        params: {
        },
        savedSearchesUrl: "/savedsearch/docestimates",
        switchDisplay: false,
        group: 'sales',
    },
    {
        id: "creditnote",
        label: window.i18n.__("Avoirs"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter un avoir"),
                "href": `javascript:DocTools.createForThird('creditnote', '${window.i18n.__('Créer un avoir')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "creditnote",
        name: "salecreditnotes",
        params: {
        },
        savedSearchesUrl: "/savedsearch/doccreditnotes",
        switchDisplay: false,
        group: 'sales',
    },
    {
        id: "creditnotedraft",
        label: window.i18n.__("Avoirs brouillon"),
        buttons: [
            {
                "label": window.i18n.__("Créer un avoir brouillon"),
                "href": `javascript:DocTools.createForThird('creditnote', '${window.i18n.__('Créer un avoir brouillon')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "creditnote",
        name: "saledraftcreditnotes",
        params: {
        },
        savedSearchesUrl: "/savedsearch/doccreditnotes",
        switchDisplay: false,
        group: 'sales',
    },
    {
        id: "order",
        label: window.i18n.__("Bons de commande"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter un bon de commande"),
                "href": `javascript:DocTools.createForThird('order', '${window.i18n.__('Créer un bon de commande')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "order",
        name: "saleorders",
        params: {
        },
        savedSearchesUrl: "/savedsearch/docorders",
        switchDisplay: false,
        favoritesName: 'saleorders',
        group: 'sales',
    },
    {
        id: "delivery",
        label: window.i18n.__("Bons de livraison"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter un bon de livraison"),
                "href": `javascript:DocTools.createForThird('delivery', '${window.i18n.__('Créer un bon de livraison')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "delivery",
        name: "saledeliveries",
        params: {
        },
        savedSearchesUrl: "/savedsearch/docdeliveries",
        switchDisplay: false,
        favoritesName: 'saledeliveries',
    },
    {
        id: "proforma",
        label: window.i18n.__("Proforma"),
        buttons: [
            {
                "label": window.i18n.__("Ajouter une facture Proforma"),
                "href": `javascript:DocTools.createForThird('proforma', '${window.i18n.__('Créer une facture proforma')}')`,
                "primary": true,
                "disabled": true,
                "permission": "create"
            },
        ],
        linkedtype: "proforma",
        name: "saleproformas",
        params: {
        },
        savedSearchesUrl: "/savedsearch/docproformas",
        switchDisplay: false,
    },
]

export default SalesListings
